/**
 * This barrel file provides the export for the lazy loaded custom material.
 */
export * from './custom-material.module';
